export default __webpack_public_path__ + "static/media/log-out2.5e7a601e.png";